export enum FiltersFormPopoverMessage {
  BUTTON_RESET_FILTERS = 'Reset filters',
  BUTTON_APPLY_FILTERS = 'Apply filters',
}
